import PlanPicker from './PlanPicker';
import PlanCustomerPortal from './PlanCustomerPortal';

export default function Plan({ blog, blogId, paymentSuccess }) {
  const { plan, expiryDate, isCancelled } = blog;
  if (plan === 'trial' || new Date(expiryDate) < new Date())
    return <PlanPicker blogId={blogId} />;
  return (
    <PlanCustomerPortal
      paymentSuccess={paymentSuccess}
      plan={plan}
      blogId={blogId}
      isCancelled={isCancelled}
      expiryDate={expiryDate}
    />
  );
}
